import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogModule, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { environment } from "environments/environment";

@Component({
    selector: "app-media-dialog",
    templateUrl: "./media-dialog.component.html",
    styleUrls: ["./media-dialog.component.scss"],
    standalone: true,
    imports: [MatDialogModule, MatIconModule]
})
export class MediaDialogComponent implements OnInit {
    file: any;
    filePath: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.filePath = environment.urlDomainEvaluationFiles;
        this.file = data.file;
    }

    ngOnInit(): void {}

    close() {
        this.data.close();
    }
}
